import { DefaultRequestOptionsBuilder as e } from "./index2.js";
import "@ado/location-library";
import "@ado/cookie-library";
function o() {
  return new e();
}
export {
  o as createRequestOptionsBuilder
};
//# sourceMappingURL=index.js.map
